import type { App, InjectionKey } from 'vue'
import type { AuthProvider } from '@/services/auth/auth-provider'
import { AmplifyAuthProvider } from '@/services/auth/amplify-auth-provider';

export const AuthProviderKey: InjectionKey<AuthProvider> = Symbol('AuthProvider')

let _provider: AuthProvider | null = null

function ensureProvider(): AuthProvider {
  if (!_provider) {
    _provider = new AmplifyAuthProvider()
  }
  return _provider
}

export const authPlugin = {
  install(app: App) {
    const provider = ensureProvider()
    provider.init()
    app.provide(AuthProviderKey, provider)
    app.config.globalProperties.$auth = provider
  }
}

/**
 * Direct access for non-component contexts (stores, interceptors).
 * Use `useAuth()` composable in Vue components instead.
 */
export function getAuth(): AuthProvider {
  return ensureProvider()
}
